import { Main } from './views/Main';

export const App = () => {
  return (
    <Main />
  );
}
